import { ClickElement } from './base-element';
import { ElementType } from './element-type';

export class Form extends ClickElement {
  submitText: string | null = null;
  maxFileUploadSize: number | null = null;

  constructor() {
    super();
    this.elementType = ElementType.form;
  }
}
